import { useBlockProps } from "@wordpress/block-editor";

export default function save({ attributes }) {
	const {
		lightBg,
		lightText,
		lightLink,
		lightIcon,
		darkBg,
		darkText,
		darkLink,
		darkIcon,
	} = attributes;

	const moon =
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-moon-fill" viewBox="0 0 16 16"><path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/></svg>';

	return (
		<button
			{...useBlockProps.save({
				className: "swiftpress-toggle",
				"data-light-bg": lightBg,
				"data-light-text": lightText,
				"data-light-link": lightLink,
				"data-light-icon": lightIcon,
				"data-dark-bg": darkBg,
				"data-dark-text": darkText,
				"data-dark-link": darkLink,
				"data-dark-icon": darkIcon,
				style: {
					cursor: "pointer",
					fontSize: "1.5rem",
					border: "none",
					background: "transparent",
					padding: "0.5rem",
				},
			})}
			aria-label="Toggle dark mode"
			dangerouslySetInnerHTML={{ __html: moon }}
		/>
	);
}
